import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import authService from '../services/authService';

const SignUpModal = ({ show, onHide }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [nickname, setNickname] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSignUp = async (e) => {
        e.preventDefault();
        if (!email || !password || !confirmPassword || !nickname) {
            setError('모든 필드를 입력해주세요.');
            return;
        }

        if (password !== confirmPassword) {
            setError('비밀번호가 일치하지 않습니다.');
            return;
        }

        // 비밀번호 유효성 검사: 8자리 이상, 특수문자 포함
        const passwordRegex = /^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
        if (!passwordRegex.test(password)) {
            setError('비밀번호는 8자리 이상이어야 하며, 특수문자를 최소 1개 포함해야 합니다.');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');

        const result = await authService.signup(email, password, nickname);

        if (result.success) {
            setSuccess(result.message);
            // Clear form after delay or immediately? User might want to see success message.
            setTimeout(() => {
                onHide();
                setSuccess('');
                setSuccess('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                setNickname('');
            }, 2000);
        } else {
            setError(result.message || '회원가입에 실패했습니다.');
        }
        setLoading(false);
    };

    const handleClose = () => {
        onHide();
        setError('');
        setSuccess('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setNickname('');
    }

    return (
        <Modal show={show} onHide={handleClose} centered contentClassName="rounded-4 shadow-lg border-0 bg-white">
            <Modal.Header closeButton>
                <Modal.Title>회원가입</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}
                {!success && (
                    <Form onSubmit={handleSignUp}>
                        <Form.Group className="mb-3" controlId="signupEmail">
                            <Form.Label>이메일</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="name@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoFocus
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="signupPassword">
                            <Form.Label>비밀번호</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="signupConfirmPassword">
                            <Form.Label>비밀번호 확인</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="signupNickname">
                            <Form.Label>닉네임</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nickname"
                                value={nickname}
                                onChange={(e) => setNickname(e.target.value)}
                            />
                        </Form.Group>
                        <div className="d-grid gap-2">
                            <Button variant="primary" type="submit" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : '회원가입'}
                            </Button>
                        </div>
                    </Form>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SignUpModal;
